import { useSearchParams } from "react-router-dom";
import { ListaWywolan } from "../components/developer/ListaWywolan.js";
import { LogiWidok } from "../components/developer/LogiWidok.js";
import { StanSystemuWidok } from "../components/developer/StanSystemuWidok.js";
import { SegmentedControl } from "../components/ui/SegmentedControl.js";

/**
 * Zakladka "Developer": historia wszystkich wywolan modeli (zapytania, odpowiedzi, tokeny, koszt), stan systemu i logi
 * aplikacji. To narzedzie diagnostyczne po zwyklym zalogowaniu, ale tresc wywolan to tresc rozmow, wiec jest zwinieta za
 * "Pokaz tresc" i ma retencje (30 dni), a serwer zapisuje w swoim logu samo id otwartego wywolania.
 *
 * Podwidok (Wywolania, Stan systemu, Logi) i filtry listy zyja w adresie (`?karta=`), zeby odswiezenie albo powrot ze
 * szczegolu wywolania nie gubil miejsca.
 */

const KARTY = [
  { wartosc: "wywolania", etykieta: "Wywołania" },
  { wartosc: "stan", etykieta: "Stan systemu" },
  { wartosc: "logi", etykieta: "Logi" },
] as const;
type Karta = (typeof KARTY)[number]["wartosc"];

function odczytajKarte(wartosc: string | null): Karta {
  return KARTY.find((k) => k.wartosc === wartosc)?.wartosc ?? "wywolania";
}

export function DeveloperPage(): React.JSX.Element {
  const [params, setParams] = useSearchParams();
  const karta = odczytajKarte(params.get("karta"));

  return (
    <>
      <h1 className="page-title">Developer</h1>
      <p className="page-lead">
        Historia wywołań modeli, stan systemu i logi aplikacji. Treść zapytań i odpowiedzi to często treść rozmów, dlatego jest
        zwinięta, a po 30 dniach znika (zostają metadane i sumy kontrolne).
      </p>

      <div className="developer-karty">
        <SegmentedControl
          etykieta="Widok"
          opcje={KARTY}
          wartosc={karta}
          // Zmiana widoku zaczyna od czystego adresu: filtry listy nie maja sensu w logach.
          onZmiana={(k) => setParams(k === "wywolania" ? new URLSearchParams() : new URLSearchParams({ karta: k }), { replace: true })}
        />
      </div>

      {karta === "wywolania" && <ListaWywolan />}
      {karta === "stan" && <StanSystemuWidok />}
      {karta === "logi" && <LogiWidok />}
    </>
  );
}
